// extracted by mini-css-extract-plugin
module.exports = {"card":"CalcCard_card__rTjsS","title":"CalcCard_title__N4yMM","content":"CalcCard_content__fpFSF","button":"CalcCard_button__GhzvW","img":"CalcCard_img__GUoCT"};